// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssetCostCenterOrderDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class AssetCostCenterOrderApiClient extends BaseCRUDApiClient<AssetCostCenterOrderDto> {
  baseUrl = this.config.apiEndpoint + '/asset-cost-center-order';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
